import React from "react";
import Grid from "@mui/material/Grid";
import _includes from "lodash/includes";
import MenuItem from "@mui/material/MenuItem";
import MoneyIcon from "@/src/assets/icons/contract/toggleable/IconMoneyEnforce";
import GoodsIcon from "@/src/assets/icons/contract/toggleable/IconGoodsEnforce";
import QuestionMarkIcon from "@/src/assets/icons/common/toggleable/IconQuestionmark";
import InputAdornment from "@mui/material/InputAdornment";
import ValidatorSelectField from "@/src/components/FormFields/ValidatorSelectField";
import { isIban, isMoney, requiredValidator } from "@/src/services/validationRules";
import { useForm } from "@/src/provider/Form/FormProvider";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import Group from "@/src/components/Wizard/Group";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { IbanInput } from "@/src/components/FormFields/MaskedInputs/IbanInput";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import wizardStyle from "@/src/components/Form/wizardStyle";
import ClientClaimedData from "@/src/components/Form/AbstractLitigationCase/ClientClaimedData";

type ContractBaseEnforceClaimProps = {
  product: AbstractCase;
};
const ContractBaseEnforceClaim = ({ product }: ContractBaseEnforceClaimProps) => {
  const { values } = useForm();

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Welches Ziel verfolgen Sie?</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorSelectField label="Zielsetzung" name="objectiveClient" validators={[requiredValidator("Bitte geben Sie Ihr Ziel an")]}>
          <MenuItem value="fulfillment">Erfüllung des Vertrags</MenuItem>
          <MenuItem value="withdrawal">Rücktritt vom Vertrag</MenuItem>
          {!_includes(["travelContract", "membershipContract", "eventContract"], product.name) && (
            <MenuItem value="replacement">Ersatz oder Austausch</MenuItem>
          )}
          {!_includes(["travelContract", "membershipContract", "eventContract"], product.name) && (
            <MenuItem value="repair">Nachbesserung oder Reparatur</MenuItem>
          )}
          <MenuItem value="reduction">Volle oder teilweise Erstattung</MenuItem>
          <MenuItem value="compensation">Schadensersatz</MenuItem>
          {!_includes(["eventContract", "serviceContract", "travelContract", "vehicleContract"], product.name) && (
            <MenuItem value="other">Andere Zielsetzung</MenuItem>
          )}
        </ValidatorSelectField>
      </Grid>
      <Grid size={12}>
        <Group
          type="radio"
          name="subjectOfDispute"
          question="Möchten Sie Geld oder den Erhalt einer Ware/Leistung einfordern?"
          options={[
            {
              labelText: "Ich möchte Geld einfordern",
              labelIcon: <MoneyIcon />,
              labelIconActive: <MoneyIcon active />,
              value: "money",
            },
            {
              labelText: "Ich möchte eine Ware oder Leistung einfordern",
              labelIcon: <GoodsIcon />,
              labelIconActive: <GoodsIcon active />,
              value: "goods",
            },
            {
              labelText: "Ich fordere etwas ganz anderes",
              labelIcon: <QuestionMarkIcon />,
              labelIconActive: <QuestionMarkIcon active />,
              value: "other",
            },
          ]}
          validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
        />
      </Grid>
      {values.subjectOfDispute === "money" && (
        <>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wie viel Geld möchten Sie einfordern?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label="Forderung in €"
              name="claimedAmountClient"
              validators={[
                requiredValidator("Bitte geben Sie Ihre Forderung an."),
                {
                  validator: isMoney,
                  message: "Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 136,15 oder 85,00",
                },
              ]}
              helperText="Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 136,15 oder 85,00"
            />
          </Grid>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wie lautet Ihre Bankverbindung, auf die der geforderte Betrag überwiesen werden soll?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label="IBAN für Rückerstattung"
              name="client.bankData.iban"
              validators={[
                {
                  validator: isIban,
                  message: "Die eingegebene IBAN ist ungültig",
                },
              ]}
              InputProps={{
                startAdornment: <InputAdornment position="start">DE</InputAdornment>,
                inputComponent: IbanInput,
              }}
              helperText={"Wenn Sie die IBAN gerade nicht wissen, lassen Sie das Feld gerne einfach leer."}
            />
          </Grid>
        </>
      )}
      <ClientClaimedData />
    </>
  );
};
export default ContractBaseEnforceClaim;
